import { render, staticRenderFns } from "./scene7.vue?vue&type=template&id=49d13d9d&scoped=true&"
import script from "./scene7.vue?vue&type=script&lang=ts&"
export * from "./scene7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d13d9d",
  null
  
)

export default component.exports